import Vue from "vue";
import Router from "vue-router";
import Login from "@/components/Login";
import ForgotMyPassword from "@/components/ForgotMyPassword";
import ResetYouPassword from "@/components/ResetYouPassword";
import Wrapper from "@/components/Wrapper";
import NotFound from "@/components/NotFound";
import Dashboard from "@/components/Dashboard";
import OrderHistory from "@/components/OrderHistory/Index";
import Subscriptions from "@/components/Subscriptions/Index";
import Cycle from "@/components/Cycle/Index";
import PurchaseFlow from "@/components/PurchaseFlow/Index";
import Order from "@/components/Order/Index";
import Checkout from "@/components/_Shared/Checkout/Index";
import CycleCheckout from "@/components/_Shared/Checkout/Cycle";
import PersonalData from "@/components/PersonalData";
import VerifyEmail from "@/components/VerifyEmail";
import SignUp from "@/components/SignUp/Index";
import Help from "@/components/Help";
import TermsOfUse from "@/components/TermsOfUse/Index";

import store from "../store";
import { page } from "vue-analytics";

Vue.use(Router);

const router = new Router({
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return {
        x: 0,
        y: 0
      };
    }
  },
  routes: [
    {
      path: "/cadastre-se",
      name: "signup",
      component: SignUp,
      meta: {
        title: "Cadastre-se para encontrar diaristas na sua cidade",
        metaTags: [
          {
            name: "description",
            content:
              "A Donamaid é um plataforma de profissionais de limpeza avaliados e que levam produtos de limpeza. Diaristas para faxinas empresariais ou residenciais."
          },
          {
            property: "og:description",
            content:
              "A Donamaid é um plataforma de profissionais de limpeza avaliados e que levam produtos de limpeza. Diaristas para faxinas empresariais ou residenciais."
          }
        ]
      }
    },
    {
      path: "/login",
      name: "login",
      component: Login,
      meta: {
        title: "O novo jeito de contratar faxinas",
        metaTags: [
          {
            name: "description",
            content:
              "Tenha acesso a centenas de profissionais de limpeza na sua cidade para faxinas na sua casa ou empresa. Limpezas por hora com produtos de limpeza."
          },
          {
            property: "og:description",
            content:
              "Tenha acesso a centenas de profissionais de limpeza na sua cidade para faxinas na sua casa ou empresa. Limpezas por hora com produtos de limpeza."
          }
        ]
      }
    },
    {
      path: "/esqueci-minha-senha",
      name: "forgot-my-password",
      component: ForgotMyPassword,
      meta: {
        title: "Recupere sua senha",
        metaTags: [
          {
            name: "description",
            content:
              "Volte a ter acesso à plataforma donamaid para contratar diaristas com referencias na sua cidade."
          },
          {
            property: "og:description",
            content:
              "Volte a ter acesso à plataforma donamaid para contratar diaristas com referencias na sua cidade."
          }
        ]
      }
    },
    {
      path: "/redefina-sua-senha/:token",
      name: "reset-your-password",
      component: ResetYouPassword
    },
    {
      path: "/verificacao-de-email",
      name: "verify-email",
      component: VerifyEmail,
      meta: {
        publicAndAuth: true
      }
    },
    {
      path: "/",
      component: Wrapper,
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: "",
          name: "dashboard",
          component: Dashboard
        },
        {
          path: "/ajuda",
          name: "help",
          component: Help
        },
        {
          path: "meus-dados",
          name: "personal-data",
          component: PersonalData
        },
        {
          path: "pedidos",
          name: "order-history",
          component: OrderHistory
        },
        {
          path: "pedidos/:order_id",
          name: "order",
          component: Order
        },
        {
          path: "assinaturas",
          name: "subscriptions",
          component: Subscriptions
        },
        {
          path: "limpeza",
          name: "purchase-flow",
          component: PurchaseFlow
        },
        {
          path: "checkout/:order_id",
          name: "checkout",
          component: Checkout
        },
        {
          path: "checkout/assinaturas/:cycle_id",
          name: "cycle-checkout",
          component: CycleCheckout
        },
        {
          path: "termos-de-uso",
          name: "terms-of-use",
          component: TermsOfUse
        },
        {
          path: ":id",
          name: "cycle",
          component: Cycle
        },
        {
          path: "*",
          name: "not-found",
          component: NotFound
        }
      ]
    },
    {
      path: "*",
      name: "not-found2",
      component: NotFound
    }
  ]
});

router.beforeEach(async (to, from, next) => {
  try {
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
    const publicAndAuth = to.matched.some(record => record.meta.publicAndAuth);
    const isAuthenticated = await store.dispatch("user/isAuthenticated");
    const answeredTermsOfUse =
      isAuthenticated && store.getters["user/answeredTermsOfUse"];

    // This goes through the matched routes from last to first, finding the closest route with a title.
    // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
    const nearestWithTitle = to.matched
      .slice()
      .reverse()
      .find(r => r.meta && r.meta.title);

    // Find the nearest route element with meta tags.
    const nearestWithMeta = to.matched
      .slice()
      .reverse()
      .find(r => r.meta && r.meta.metaTags);

    // If a route with a title was found, set the document (page) title to that value.
    if (nearestWithTitle)
      document.title = "Donamaid - " + nearestWithTitle.meta.title;

    // Remove any stale meta tags from the document using the key attribute we set below.
    Array.from(document.querySelectorAll("[data-vue-router-controlled]")).map(
      el => el.parentNode.removeChild(el)
    );

    if (nearestWithMeta) {
      // Turn the meta tag definitions into actual elements in the head.
      nearestWithMeta.meta.metaTags
        .map(tagDef => {
          const tag = document.createElement("meta");

          Object.keys(tagDef).forEach(key => {
            tag.setAttribute(key, tagDef[key]);
          });

          // We use this to track which meta tags we create, so we don't interfere with other ones.
          tag.setAttribute("data-vue-router-controlled", "");

          return tag;
        })
        .forEach(tag => document.head.appendChild(tag));
    }

    page(to.fullPath);
    fbq("track", "PageView", to.fullPath);

    store.dispatch("menu/changeMenuOpened", false);
    store.dispatch("menu/changeRoute", to.name);

    if (requiresAuth && !isAuthenticated)
      return router.push({
        name: "login",
        params: {
          lastRoute: to
        }
      });

    if (isAuthenticated && !answeredTermsOfUse && to.name !== "terms-of-use") {
      return router.push({ name: "terms-of-use" });
    }

    if (answeredTermsOfUse && to.name === "terms-of-use") {
      return router.push({ name: "dashboard" });
    }

    if (!requiresAuth && isAuthenticated && !publicAndAuth)
      return router.push({
        name: "purchase-flow"
      });

    next();
  } catch (e) {
    return router.push({
      name: "login",
      params: {
        lastRoute: to
      }
    });
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js